export default {
  stats: {
    title: "Stats",
    tabs: {
      team: "Team-Stats",
      player: "Spieler-Stats",
    },
    empty: {
      unavailable: "Stats sind derzeit nicht verfügbar.",
    },
    filters: {
      titles: {
        qualifier: "Modus",
        type: "Typ",
        position: "Position",
      },
      plurals: {
        qualifier: "Modi",
        type: "Typen",
        position: "Positionen",
      },
      options: {
        qualifier: {
          averageStats: "Pro Spiel",
          cumulativeStats: "Gesamt",
        },
        type: {
          offensive: "Offensiv",
          defensive: "Defensiv",
        },
      },
    },
  },
};
